// === Session / Caja ===
export interface AbrirCajaRequest {
  idCajaBanco: number;
  idPuntoDeVenta: number;
  idSucursal: number;
  montoApertura: number;
  observaciones?: string;
}

export interface CerrarCajaRequest {
  idSesionCaja: number;
  montoCierre: number;
  observaciones?: string;
}

export interface SesionCajaResponse {
  idSesionCaja: number;
  idCajaBanco: number;
  cajaNombre?: string;
  idUsuario: number;
  usuarioNombre?: string;
  idPuntoDeVenta: number;
  idSucursal: number;
  montoApertura: number;
  montoCierre?: number;
  montoEsperado?: number;
  fechaApertura: string;
  fechaCierre?: string;
  estado: string;
  observaciones?: string;
  totalVentas: number;
  totalIngresos: number;
  totalEgresos: number;
}

// === Orden POS ===
export interface CrearOrdenRequest {
  tipoOrden: string;
  idMesa?: number;
  idCliente?: number;
  idMozo?: number;
  observaciones?: string;
}

export interface AgregarItemRequest {
  idArticulo: number;
  descripcion?: string;
  unidadMedida?: string;
  cantidad: number;
  precioUnitario: number;
  descuento?: number;
  porcentajeDescuento?: number;
  notas?: string;
}

export interface EmitirOrdenRequest {
  idOrdenPos: number;
  idComprobante: number;
  idPersona: number;
  serie: string;
  idTalonario?: number;
  idTipoVenta?: number;
  idFormaPago?: number;
  incluyeIGV: string;
  porcentajeIGV: number;
  idDeposito?: number;
  observaciones?: string;
}

export interface TalonarioOption {
  idTalonario: number;
  serie: string;
  proximoNumero: number;
}

export interface OrdenPosResponse {
  idOrdenPos: number;
  numeroOrden: string;
  tipoOrden: string;
  estado: string;
  idMesa?: number;
  mesaNumero?: number;
  idCliente?: number;
  clienteNombre?: string;
  mozoNombre?: string;
  subTotal: number;
  totalIGV: number;
  totalDescuento: number;
  total: number;
  fechaCreacion: string;
  observaciones?: string;
  detalles: OrdenPosDetalleResponse[];
}

export interface OrdenPosDetalleResponse {
  idOrdenPosDetalle: number;
  idArticulo: number;
  descripcion?: string;
  unidadMedida?: string;
  cantidad: number;
  precioUnitario: number;
  descuento: number;
  subTotal: number;
  igv: number;
  total: number;
  estado: string;
  notas?: string;
  numeroLinea: number;
}

// === Caja Movimientos ===
export interface MovimientoCajaRequest {
  tipo: string;
  concepto: string;
  monto: number;
  descripcion?: string;
}

export interface MovimientoCajaResponse {
  idMovimientoCaja: number;
  tipo: string;
  concepto: string;
  monto: number;
  descripcion?: string;
  fechaMovimiento: string;
  usuarioNombre?: string;
}

export interface ResumenCajaResponse {
  montoApertura: number;
  totalVentas: number;
  totalIngresos: number;
  totalEgresos: number;
  montoEsperado: number;
  cantidadVentas: number;
  cantidadIngresos: number;
  cantidadEgresos: number;
  movimientos: MovimientoCajaResponse[];
}

// === Mesa / Restaurante ===
export interface PisoResponse {
  idPiso: number;
  nombre: string;
  descripcion?: string;
  orden: number;
  mesas: MesaResponse[];
}

export interface MesaResponse {
  idMesa: number;
  numero: number;
  nombre?: string;
  capacidad: number;
  estado: string;
  mozoNombre?: string;
  idOrdenActiva?: number;
  totalOrdenActiva?: number;
  horaApertura?: string;
}

export interface TransferirMesaRequest {
  idMesaDestino: number;
}

export interface SepararCuentaRequest {
  itemIds: number[];
}

// === Constants ===
export const ESTADOS_MESA = {
  DISPONIBLE: 'DISPONIBLE',
  OCUPADA: 'OCUPADA',
  RESERVADA: 'RESERVADA',
  POR_COBRAR: 'POR_COBRAR',
  CERRADA: 'CERRADA',
} as const;

export const ESTADOS_ORDEN = {
  ABIERTA: 'ABIERTA',
  EN_PREPARACION: 'EN_PREPARACION',
  LISTA: 'LISTA',
  FACTURADA: 'FACTURADA',
  CANCELADA: 'CANCELADA',
} as const;

export const TIPOS_ORDEN = {
  RETAIL: 'RETAIL',
  RESTAURANTE: 'RESTAURANTE',
  DELIVERY: 'DELIVERY',
} as const;

// === Initial States ===
export const initialAbrirCaja: AbrirCajaRequest = {
  idCajaBanco: 0,
  idPuntoDeVenta: 0,
  idSucursal: 0,
  montoApertura: 0,
};

export const initialEmitirOrden: EmitirOrdenRequest = {
  idOrdenPos: 0,
  idComprobante: 0,
  idPersona: 0,
  serie: '',
  incluyeIGV: 'S',
  porcentajeIGV: 18,
};
